export default __webpack_public_path__ + "static/media/634.58189908.png";